import { render } from "./ToptoBottom.vue?vue&type=template&id=1d096cd4"
import script from "./ToptoBottom.vue?vue&type=script&lang=js"
export * from "./ToptoBottom.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__